export default __webpack_public_path__ + "static/banner-finance-debt-consolidation-f0c545aab6d33f45dc6b6e30a7780d9b.jpg";